const statge_data=[
    {id:1,jobname:"frontend developer",jobstatus:"NA"},
    {id:2,jobname:"backend developer",jobstatus:"NA"},
    {id:3,jobname:"fullstack developer",jobstatus:"NA"},
    {id:4,jobname:"software engineer",jobstatus:"NA"},
    {id:5,jobname:"programmer",jobstatus:"NA"},
    {id:6,jobname:"data analyst",jobstatus:"NA"},
    {id:7,jobname:"project manager",jobstatus:"NA"},
    {id:8,jobname:"senior manager",jobstatus:"NA"}
]


export default statge_data;